export default "/assets/images/chair.d199cc080ae4b065.png";